import React from 'react';
import PropTypes from 'prop-types';
import TeeTimesGroup from './tee-times-group';

const TeeTimesList = ({ groups, sitecorePlayers, ...props }) => {
    if (!Array.isArray(groups) || !sitecorePlayers) return null;

    return (
        <div aria-live="polite">
            {
                groups.map((group, i) =>
                    <TeeTimesGroup
                        key={group.id}
                        sitecorePlayers={sitecorePlayers}
                        model={group}
                        isEven={i % 2 !== 0}
                        {...props}
                    />)
            }
        </div>
    );
};

TeeTimesList.propTypes = {
    groups: PropTypes.array,
};

export default TeeTimesList;
